import React, { useState } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import * as Icons from '@fortawesome/fontawesome-free-solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  Button,
  Collapse,
  FormControl,
  Grid,
  InputLabel,
  List,
  ListItem,
  MenuItem,
  Select,
  Typography,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import TranslateIcon from '@material-ui/icons/Translate'
import clsx from 'clsx'
import { Link, changeLocale } from 'gatsby-plugin-intl'

import IconAlerts from '~/assets/icons/alert.svg'
import IconAppreciations from '~/assets/icons/appreciations.svg'
import IconPayments from '~/assets/icons/credit_card.svg'
import IconDigitalID from '~/assets/icons/digital_id.svg'
import IconEvents from '~/assets/icons/events_light.svg'
import IconMarketplace from '~/assets/icons/marketplace.svg'
import IconProposals from '~/assets/icons/proposals.svg'
import IconRequests from '~/assets/icons/requests.svg'
import IconSuggestions from '~/assets/icons/suggestions.svg'
import Logo from '~/assets/resident_logo_with_text_filled.svg'
import { Container } from '~/components/global'
import { Links } from '~/constants/links'
import translate, { getLocale } from '~/locale'
import '~/styles/custom/menuCities.scss'

import Login from './login'
import MenuCities from './menuCities'

function TabPanel(props) {
  const { children, value, index, ...other } = props

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </Typography>
  )
}

const mapStateToProps = (state) => ({
  labels: state.firebase.labels.items,
})

function Navigation({ labels, login }) {
  const locales = {
    en: 'English',
    fr: 'Français',
    es: 'Español',
    pt: 'Português',
  }

  const [value, setValue] = useState(0)
  const handleChange = (event, newValue) => {
    setValue(newValue)
  }

  const [language, setLanguage] = useState(locales[getLocale()])

  const handleLanguageChange = (code) => {
    setLanguage(locales[code])

    setCollapse(false)

    changeLocale(code)
  }

  const [collapse, setCollapse] = useState(false)
  const toggle = () => setCollapse(!collapse)

  return (
    <>
      <div className="header-nav-wrapper header-nav-wrapper-lg navbar-light">
        <StyledContainer>
          <div className="app-nav-logo">
            <Link
              to="/"
              title="Bamburgh React Admin Dashboard with Material-UI PRO"
              className="app-nav-logo app-nav-logo--dark"
            >
              <div className="app-nav-logo">
                <Logo />
              </div>
            </Link>
          </div>
          <div className="header-nav-menu d-none d-lg-block">
            <ul className="d-flex nav nav-neutral-first justify-content-end">
              <li>
                <a
                  href="#/"
                  onClick={(e) => e.preventDefault()}
                  className="font-weight-500 rounded-lg text-baseline-secondary px-3"
                >
                  {translate('website_menu_forresidents')}
                  <span className="opacity-5 dropdown-arrow">
                    <FontAwesomeIcon icon={['fas', 'angle-down']} />
                  </span>
                </a>
                <div className="submenu-dropdown submenu-dropdown--xxl">
                  <Grid container spacing={0}>
                    <div className="w-30 d-flex align-items-center">
                      <div className="shadow-sm-dark w-100 bg-secondary-dark p-3 rounded-left">
                        <div className="px-2 text-uppercase pb-2 text-primary-light font-weight-500 font-size-sm">
                          {translate('simplifyyourlife')}
                        </div>
                        <List
                          component="div"
                          className="nav-pills nav-transparent nav-pills-rounded flex-column"
                        >
                          <ListItem
                            button
                            component={Link}
                            to={Links.FEATURES_PAYMENTS}
                            className="px-2 mb-3 d-flex align-items-center"
                          >
                            <div className="mw-100 d-flex flex-row align-items-center">
                              <ListIconWrapper>
                                <IconPayments />
                              </ListIconWrapper>
                              <ListContentWrapper className="pill">
                                <span className="item-title">
                                  {translate('payments')}
                                </span>
                                <span className="item-description">
                                  {translate(
                                    'settle_any_amounts_you_owe_your_city',
                                  )}
                                </span>
                              </ListContentWrapper>
                            </div>
                          </ListItem>
                          <ListItem
                            button
                            component={Link}
                            to={Links.FEATURES_DIGITAL_ID}
                            className="px-2 mb-3 d-flex align-items-center"
                          >
                            <div className="mw-100 d-flex flex-row align-items-center">
                              <ListIconWrapper>
                                <IconDigitalID />
                              </ListIconWrapper>
                              <ListContentWrapper className="pill">
                                <span className="item-title">
                                  {translate('digital_id')}
                                </span>
                                <span className="item-description">
                                  {translate(
                                    'facilitate_routine_personal_identification',
                                  )}
                                </span>
                              </ListContentWrapper>
                            </div>
                          </ListItem>
                          <ListItem
                            button
                            component={Link}
                            to={Links.FEATURES_MARKETPLACE}
                            className="px-2 d-flex align-items-center"
                          >
                            <div className="mw-100 d-flex flex-row align-items-center">
                              <ListIconWrapper>
                                <IconMarketplace />
                              </ListIconWrapper>
                              <ListContentWrapper className="pill">
                                <span className="item-title">
                                  {translate('marketplace_title_text')}
                                </span>
                                <span className="item-description">
                                  {translate('findhirepay')}
                                </span>
                              </ListContentWrapper>
                            </div>
                          </ListItem>
                        </List>
                      </div>
                    </div>
                    <div className="w-40 z-over">
                      <div className="shadow-sm-dark w-100 bg-white py-4 px-3 rounded mid-menu">
                        <div className="px-2 text-uppercase pb-2 text-primary font-weight-500 font-size-sm">
                          {translate('speakyourmind')}
                        </div>
                        <List
                          component="div"
                          className="nav-pills nav-neutral-primary nav-pills-rounded flex-column"
                        >
                          <ListItem
                            button
                            component={Link}
                            to={Links.FEATURES_REQUESTS}
                            className="px-2 mb-3 d-flex align-items-center"
                          >
                            <div className="d-flex flex-row align-items-center">
                              <ListIconWrapper>
                                <IconRequests />
                              </ListIconWrapper>
                              <ListContentWrapper>
                                <span className="item-title">
                                  {translate('requests_title_text')}
                                </span>
                                <span className="item-description">
                                  {translate('helpyourcity')}
                                </span>
                              </ListContentWrapper>
                            </div>
                          </ListItem>
                          <ListItem
                            button
                            component={Link}
                            to={Links.FEATURES_SUGGESTIONS}
                            className="px-2 mb-3 d-flex align-items-center"
                          >
                            <div className="d-flex flex-row align-items-center">
                              <ListIconWrapper>
                                <IconSuggestions />
                              </ListIconWrapper>
                              <ListContentWrapper>
                                <span className="item-title">
                                  {translate('suggestions_title_text')}
                                </span>
                                <span className="item-description">
                                  {translate('speakyourmind2')}
                                </span>
                              </ListContentWrapper>
                            </div>
                          </ListItem>
                          <ListItem
                            button
                            component={Link}
                            to={Links.FEATURES_APPRECIATIONS}
                            className="px-2 d-flex align-items-center"
                          >
                            <div className="d-flex flex-row align-items-center">
                              <ListIconWrapper>
                                <IconAppreciations />
                              </ListIconWrapper>
                              <ListContentWrapper>
                                <span className="item-title">
                                  {translate('appreciations')}
                                </span>
                                <span className="item-description">
                                  {translate('somethingyoulike')}
                                </span>
                              </ListContentWrapper>
                            </div>
                          </ListItem>
                        </List>
                      </div>
                    </div>
                    <div className="w-30 d-flex align-items-center">
                      <div className="shadow-sm-dark w-100 bg-secondary-dark p-3 rounded-right">
                        <div className="px-2 text-uppercase pb-2 text-primary-light font-weight-500 font-size-sm">
                          {translate('hearfromyourcity')}
                        </div>
                        <List
                          component="div"
                          className="nav-pills nav-transparent nav-pills-rounded flex-column"
                        >
                          <ListItem
                            button
                            component={Link}
                            to={Links.FEATURES_PROPOSALS}
                            className="px-2 mb-3 d-flex align-items-center"
                          >
                            <div className="mw-100 d-flex flex-row align-items-center">
                              <ListIconWrapper>
                                <IconProposals />
                              </ListIconWrapper>
                              <ListContentWrapper className="pill">
                                <span className="item-title">
                                  {translate('proposals_title_text')}
                                </span>
                                <span className="item-description">
                                  {translate('voteonmatters')}
                                </span>
                              </ListContentWrapper>
                            </div>
                          </ListItem>
                          <ListItem
                            button
                            component={Link}
                            to={Links.FEATURES_ALERTS}
                            className="px-2 mb-3 d-flex align-items-center"
                          >
                            <div className="mw-100 d-flex flex-row align-items-center">
                              <ListIconWrapper>
                                <IconAlerts />
                              </ListIconWrapper>
                              <ListContentWrapper className="pill">
                                <span className="item-title">
                                  {translate('alerts_live')}
                                </span>
                                <span className="item-description">
                                  {translate('realtimeemergency')}
                                </span>
                              </ListContentWrapper>
                            </div>
                          </ListItem>
                          <ListItem
                            button
                            component={Link}
                            to={Links.FEATURES_EVENTS}
                            className="px-2 d-flex align-items-center"
                          >
                            <div className="mw-100 d-flex flex-row align-items-center">
                              <ListIconWrapper>
                                <IconEvents />
                              </ListIconWrapper>
                              <ListContentWrapper className="pill">
                                <span className="item-title">
                                  {translate('events_title_text')}
                                </span>
                                <span className="item-description">
                                  {translate('meetyourneighbour')}
                                </span>
                              </ListContentWrapper>
                            </div>
                          </ListItem>
                        </List>
                      </div>
                    </div>
                  </Grid>
                </div>
              </li>
              <li>
                <a
                  href="#/"
                  onClick={(e) => e.preventDefault()}
                  className="font-weight-500 rounded-lg text-baseline-secondary px-3"
                >
                  {translate('forcities')}
                  <span className="opacity-5 dropdown-arrow">
                    <FontAwesomeIcon icon={['fas', 'angle-down']} />
                  </span>
                </a>
                <div className="submenu-dropdown">
                  <Grid container spacing={0}>
                    <MenuCities />
                  </Grid>
                </div>
              </li>
              <li>
                <a
                  href="#/"
                  onClick={(e) => e.preventDefault()}
                  className="font-weight-500 rounded-lg text-baseline-secondary px-3"
                >
                  <span className="mr-2">
                    <TranslateIcon />
                  </span>
                  {language}
                  <span className="opacity-5 dropdown-arrow">
                    <FontAwesomeIcon icon={['fas', 'angle-down']} />
                  </span>
                </a>
                <div className="submenu-dropdown submenu-dropdown--xs">
                  <Grid container spacing={0}>
                    <div className="w-100 z-over">
                      <div className="shadow-sm-dark w-100 bg-white py-1 px-3 rounded">
                        <List
                          component="div"
                          className="nav-pills nav-neutral-primary nav-pills-rounded flex-column"
                        >
                          {Object.entries(locales).map(([key, value]) => (
                            <ListItem
                              button
                              onClick={() => handleLanguageChange(key)}
                              className="px-2 py-2 d-flex align-items-center"
                              key={key}
                            >
                              {value}
                            </ListItem>
                          ))}
                        </List>
                      </div>
                    </div>
                  </Grid>
                </div>
              </li>
            </ul>
          </div>
          <div className="header-nav-actions flex-grow-0">
            <span className="d-none d-lg-block">
              <Login login={login} />
            </span>
            <span className="d-block d-lg-none">
              <button
                onClick={toggle}
                className={clsx('navbar-toggler hamburger hamburger--elastic', {
                  'is-active': collapse,
                })}
              >
                <span className="hamburger-box">
                  <span className="hamburger-inner" />
                </span>
              </button>
            </span>
          </div>
        </StyledContainer>
        <div className="d-flex d-lg-none">
          <Collapse
            in={collapse}
            className="nav-collapsed-wrapper shadow-lg navbar-collapse"
          >
            <div className="nav-inner-wrapper">
              <Button
                onClick={toggle}
                className="btn-danger btn-icon d-40 shadow-sm hover-scale-lg btn-animated-icon-sm nav-toggle-inner-btn p-0"
              >
                <span className="btn-wrapper--icon">
                  <FontAwesomeIcon icon={['fas', 'times']} />
                </span>
              </Button>
              <div className="pt-3 px-3">
                <div className="px-4 text-uppercase pb-2 text-primary font-weight-500 font-size-sm">
                  {translate('speakyourmind')}
                </div>
                <List
                  component="div"
                  className="nav-pills nav-neutral-primary mb-3 nav-pills-rounded flex-column"
                >
                  <ListItem
                    button
                    component={Link}
                    to={Links.FEATURES_REQUESTS}
                    className="px-4 d-flex align-items-center"
                  >
                    <span>{translate('requests_title_text')}</span>
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="opacity-6 ml-auto"
                    />
                  </ListItem>
                  <ListItem
                    button
                    component={Link}
                    to={Links.FEATURES_SUGGESTIONS}
                    className="px-4 d-flex align-items-center"
                  >
                    <span>{translate('suggestions_title_text')}</span>
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="opacity-6 ml-auto"
                    />
                  </ListItem>
                  <ListItem
                    button
                    component={Link}
                    to={Links.FEATURES_APPRECIATIONS}
                    className="px-4 d-flex align-items-center"
                  >
                    <span>{translate('appreciation_title_text')}</span>
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="opacity-6 ml-auto"
                    />
                  </ListItem>
                </List>
                <div className="px-4 text-uppercase pb-2 text-primary font-weight-500 font-size-sm">
                  {translate('hearfromyourcity')}
                </div>
                <List
                  component="div"
                  className="nav-pills nav-neutral-primary nav-pills-rounded flex-column"
                >
                  <ListItem
                    button
                    component={Link}
                    to={Links.FEATURES_PROPOSALS}
                    className="px-4 d-flex align-items-center"
                  >
                    <span>{translate('proposals_title_text')}</span>
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="opacity-6 ml-auto"
                    />
                  </ListItem>
                  <ListItem
                    button
                    component={Link}
                    to={Links.FEATURES_ALERTS}
                    className="px-4 d-flex align-items-center"
                  >
                    <span>{translate('alerts_live')}</span>
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="opacity-6 ml-auto"
                    />
                  </ListItem>
                  <ListItem
                    button
                    component={Link}
                    to={Links.FEATURES_EVENTS}
                    className="px-4 d-flex align-items-center"
                  >
                    <span>{translate('events_title_text')}</span>
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="opacity-6 ml-auto"
                    />
                  </ListItem>
                </List>
                <div className="px-4 text-uppercase py-2 text-primary font-weight-500 font-size-sm">
                  {translate('simplifyyourlife')}
                </div>
                <List
                  component="div"
                  className="nav-pills nav-neutral-primary mb-3 nav-pills-rounded flex-column"
                >
                  <ListItem
                    button
                    component={Link}
                    to={Links.FEATURES_PAYMENTS}
                    className="px-4 d-flex align-items-center"
                  >
                    <span>{translate('payments')}</span>
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="opacity-6 ml-auto"
                    />
                  </ListItem>
                  <ListItem
                    button
                    component={Link}
                    to={Links.FEATURES_DIGITAL_ID}
                    className="px-4 d-flex align-items-center"
                  >
                    <span>{translate('digital_id')}</span>
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="opacity-6 ml-auto"
                    />
                  </ListItem>
                  <ListItem
                    button
                    component={Link}
                    to={Links.FEATURES_MARKETPLACE}
                    className="px-4 d-flex align-items-center"
                  >
                    <span>{translate('marketplace_title_text')}</span>
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="opacity-6 ml-auto"
                    />
                  </ListItem>
                </List>
                <div className="px-4 text-uppercase pb-2 text-primary font-weight-500 font-size-sm">
                  {translate('cities')}
                </div>
                <List
                  component="div"
                  className="nav-pills nav-neutral-primary mb-3 nav-pills-rounded flex-column"
                >
                  <ListItem
                    button
                    component={Link}
                    to={Links.CITIES_SETUP}
                    className="px-4 d-flex align-items-center"
                  >
                    <span>{translate('set_up')}</span>
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="opacity-6 ml-auto"
                    />
                  </ListItem>
                  <ListItem
                    button
                    component={Link}
                    to={Links.CITIES_COACHING}
                    className="px-4 d-flex align-items-center"
                  >
                    <span>{translate('coaching')}</span>
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="opacity-6 ml-auto"
                    />
                  </ListItem>
                  <ListItem
                    button
                    component={Link}
                    to={Links.CITIES_CITYCARE}
                    className="px-4 d-flex align-items-center"
                  >
                    <span>{translate('citycare')}</span>
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="opacity-6 ml-auto"
                    />
                  </ListItem>
                  <ListItem
                    button
                    component={Link}
                    onClick={toggle}
                    to={Links.CITIES_PRICING}
                    className="px-4 d-flex align-items-center"
                  >
                    <span>{translate('pricing.20')}</span>
                    <FontAwesomeIcon
                      icon={['fas', 'angle-right']}
                      className="opacity-6 ml-auto"
                    />
                  </ListItem>
                </List>
                <div className="px-4 text-uppercase pb-2 text-primary font-weight-500 font-size-sm">
                  Languages
                </div>
                <List
                  component="div"
                  className="nav-pills nav-neutral-primary nav-pills-rounded flex-column"
                >
                  {Object.entries(locales).map(([key, value]) => (
                    <ListItem
                      button
                      onClick={() => handleLanguageChange(key)}
                      className="px-4 py-2 d-flex align-items-center"
                      key={key}
                    >
                      {value}
                      <FontAwesomeIcon
                        icon={['fas', 'angle-right']}
                        className="opacity-6 ml-auto"
                      />
                    </ListItem>
                  ))}
                </List>
              </div>
            </div>
          </Collapse>
        </div>
      </div>
      {/* <div className={clsx("collapse-page-trigger", { "is-active": collapse })} onClick={toggle} /> */}
    </>
  )
}

const StyledContainer = styled(Container)`
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .header-nav-menu {
    margin-right: 180px;
  }
`

const ListIconWrapper = styled.div`
  margin-right: 15px;
  width: 28px;
`

const ListContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  .item-title {
    ${(props) => props.theme.typography.subtitle2}
    color: ${(props) => props.theme.color.text_primary};
  }

  .item-description {
    ${(props) => props.theme.typography.bottom_navigation}
    color: ${(props) => props.theme.color.text_disabled}
  }

  &.pill {
    max-width: 100%;

    .item-title {
      color: ${(props) => props.theme.color.white.regular};
    }

    .item-description {
      color: ${(props) => props.theme.color.primary_light};
      width: calc(100%);
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: inherit;
    }
  }
`

export default connect(mapStateToProps, null)(Navigation)
